import { PersistentWorkItem } from './persistent-work-item';

/**
 * The workflow object interface.
 */
export interface PersistentWorkflow {
    /**
     * The name of module.
     */
    moduleName: string;

    /**
     * The name of workflow.
     */
    name: string;

    /**
     * The version of workflow.
     */
    version: number;

    /**
     * The collection of work items.
     */
    collection: PersistentWorkItem<any>[];
}
